/**
 * @generated SignedSource<<45ee832797c03b8798f69beb928ca933>>
 * @relayHash f8669320f615468380f6b7329bb72c76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6546241374c7e5f338745b6f42592108f946e14ec69934c2a80661773984a24e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_EditionAwarenessTrialModalQuery } from './main_EditionAwarenessTrialModalQuery.graphql';

const node: PreloadableConcreteRequest<main_EditionAwarenessTrialModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6546241374c7e5f338745b6f42592108f946e14ec69934c2a80661773984a24e",
    "metadata": {},
    "name": "main_EditionAwarenessTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
